
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"80","height":"80","viewBox":"0 0 96.95 96.95"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#b6b7bb","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"5","data-name":"report 1"}},[_c('path',{attrs:{"d":"M32.317 8.085v12.128"}}),_c('path',{attrs:{"data-name":"Vector","d":"M64.633 8.085v12.128M28.267 52.515h32.341M28.272 68.673h20.213M64.628 14.149c13.45.727 20.194 5.856 20.194 24.838v24.962c0 16.639-4.039 24.959-24.231 24.959H36.359c-20.192-.003-24.231-8.323-24.231-24.959V38.987c0-18.982 6.744-24.071 20.193-24.838z"}})])])
          )
        }
      }
    